<template>
  <v-form v-model="valid" class="pa-3">
    <v-text-field
      v-model="fullName"
      :rules="nameRules"
      :counter="10"
      label="שם מלא"
      required
      color="#ff684d"
    ></v-text-field>

    <v-text-field v-model="email" :rules="emailRules" label="כתובת אימייל" required color="#ff684d"></v-text-field>

    <v-text-field v-model="phone" :rules="phoneRules" label="מספר טלפון" required color="#ff684d"></v-text-field>

    <v-select :items="testDateOptions" :rules="testDateRules" v-model="testDate" label="מועד הבחינה"></v-select>

    <v-btn color="#ff684d" @click="submit" :disabled="!valid" class="white--text">שליחה</v-btn>
  </v-form>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    fullName: "",
    nameRules: [v => !!v || "חובה למלא שם"],
    phone: "",
    phoneRules: [
      v => !!v || "חובה למלא מספר טלפון",
      v => (v && v.length >= 9) || "נא להזין מספר טלפון תקין"
    ],
    email: "",
    emailRules: [
      v => !!v || "חובה למלא כתובת אימייל",
      v => /.+@.+\..+/.test(v) || "נא להזין כתובת אימייל תקינה"
    ],
    testDate: "",
    testDateOptions: [
      "אפריל 2024",
      "נובמבר 2024",
      "אפריל 2025",
      "אוקטובר 2025",
      "אני עדיין סטודנט"
    ],
    testDateRules: [v => !!v || "חובה למלא שדה זה"]
  }),
  methods: {
    submit() {
      let payload = {
        fullName: this.fullName,
        phone: this.phone,
        email: this.email,
        testDate: this.testDate
      };
      this.$emit("submitForm", payload);
    }
  }
};
</script>